import { NgModule, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-genericmodal',
  templateUrl: './genericmodal.component.html',
  styleUrls: ['./genericmodal.component.scss'],
})

export class GenericmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
